<template>
  <div id="event-program-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-row>
            <el-col :span="24" class="event-program-type-select">
              <div class="item" :class="{ active: form.type == 0 }" @click="changeFormType(0)">
                <div class="icon">
                  <i class="far fa-calendar-alt"></i>
                </div>
                <div class="item-content">
                  <div class="head">{{ $t("contentManagement.eventProgram.components.session") }}</div>
                  <div class="sub">{{ $t("contentManagement.eventProgram.components.includesTitleContent") }}</div>
                </div>
              </div>
              <div class="item " :class="{ active: form.type == 1 }" @click="changeFormType(1)" v-show="$store.state.eventprogram.subEvents.length > 0">
                <div class="icon">
                  <i class="fas fa-link"></i>
                </div>
                <div class="item-content">
                  <div class="head">{{ $t("contentManagement.eventProgram.components.subEvent") }}</div>
                  <div class="sub">{{ $t("contentManagement.eventProgram.components.createSessionSubEvent") }}</div>
                </div>
              </div>
              <div class="item " :class="{ active: form.type == 2 }" @click="changeFormType(2)">
                <div class="icon">
                  <i class="fas fa-book"></i>
                </div>
                <div class="item-content">
                  <div class="head">{{ $t("contentManagement.eventProgram.components.section") }}</div>
                  <div class="sub">{{ $t("contentManagement.eventProgram.components.sessionGroup") }}</div>
                </div>
              </div>
              <div class="item " :class="{ active: form.type == 3 }" @click="changeFormType(3)">
                <div class="icon">
                  <i class="fas fa-coffee"></i>
                </div>
                <div class="item-content">
                  <div class="head">{{ $t("contentManagement.eventProgram.components.break") }}</div>
                  <div class="sub">{{ $t("contentManagement.eventProgram.components.breakMsg") }}</div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-3" v-if="form.type == 1">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.subeventSelection") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.subEventPublishInfoMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-select v-model="form.subEventID">
                  <el-option v-for="subevent in $store.state.eventprogram.subEvents" :key="subevent.id" :value="subevent.id" :label="subevent.title" :style="subevent.isActive ? '' : 'background-color: #fff2f2;'"></el-option>
                </el-select>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row class="mt-3" :gutter="10">
            <el-col :span="16">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.title") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.programTitleMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.saloonSelection") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.defineSaloonMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>

                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.eventProgram.components.subEventPublishInfoMsg") }}</span>
                    </div>
                    <i class="el-icon-circle-plus" style="color:#03658c;" @click="saloonModal = !saloonModal"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="form.saloonID" :class="$inputError('saloonID', validationErrors)" clearable @clear="form.saloonID == null">
                  <el-option v-for="saloon in $store.state.eventprogram.saloons" :key="saloon.id" :value="saloon.id" :label="saloon.title" :style="saloon.isActive ? '' : 'background-color: #fff2f2;'">
                    <template>
                      <i class="fas fa-square mr-2" :style="{ color: saloon.color }"></i>
                      <span>{{ saloon.title }}</span>
                    </template>
                  </el-option>
                </el-select>
                <span class="error">{{ $errorMessage("saloonID", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row class="mt-3" :gutter="10">
            <el-col :span="9">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.daySelection") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.defineDayMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.eventProgram.components.subEventPublishInfoMsg") }}</span>
                    </div>
                    <i class="el-icon-circle-plus" style="color:#03658c;" @click="dayModal = !dayModal"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="form.dayID" :class="$inputError('dayID', validationErrors)">
                  <el-option v-for="day in $store.state.eventprogram.days" :key="day.id" :value="day.id" :label="day.title + ' - ' + $moment(day.date).format('DD MMMM YYYY')" :style="day.isActive ? '' : 'background-color: #fff2f2;'">
                    <template>
                      <span>
                        <b>{{ day.title }}</b>
                        - {{ $moment(day.date).format("DD MMMM YYYY") }}
                      </span>
                    </template>
                  </el-option>
                </el-select>
                <span class="error">{{ $errorMessage("dayID", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.startTime") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.startTimeMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-time-select
                  :class="$inputError('startTime', validationErrors)"
                  style="width:100%;"
                  v-model="form.startTime"
                  clearable
                  @clear="form.starTime = null"
                  :placeholder="$t('contentManagement.eventProgram.components.specifyTime')"
                  :picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:59'
                  }"
                ></el-time-select>
                <span class="error">{{ $errorMessage("startTime", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.endTime") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.endTimeMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-time-select
                  style="width:100%;"
                  :class="$inputError('endTime', validationErrors)"
                  v-model="form.endTime"
                  clearable
                  @clear="form.endTime = null"
                  :placeholder="$t('contentManagement.eventProgram.components.specifyTime')"
                  :picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:59'
                  }"
                ></el-time-select>
                <span class="error">{{ $errorMessage("endTime", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.calculateTime") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.calculateTimeMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="time-differ">
                  <i class="ml-1 el-icon-time"></i>
                  {{ getTimeDiffer }}
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-3" v-if="form.type != 2 && form.type != 3">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.content") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.contentDetails") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="form.details" />
                <span class="error">{{ $errorMessage("details", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row class="mt-3" v-if="form.type == 3">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("contentManagement.eventProgram.components.badgeSelect") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("contentManagement.eventProgram.components.badgeSelectMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-select v-model="form.badgeTitle" :class="$inputError('badgeTitle', validationErrors)">
                  <el-option v-for="(icon, index) in iconList" :key="index" :value="icon.value" :label="icon.title">
                    <i :class="icon.value"></i>
                    {{ icon.title }}
                  </el-option>
                  <template slot="prefix">
                    <span class="badge-prefix">
                      <i :class="form.badgeTitle"></i>
                    </span>
                  </template>
                </el-select>
                <span class="error">{{ $errorMessage("badgeTitle", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form.type != 2 && form.type != 3">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsSpeaker = !settingsSpeaker">
                  <div class="section-title">
                    <div class="section-head">
                      <label :class="{ 'text-danger': validationErrors.some(x => x.key.includes('speakers')) }">{{ $t("contentManagement.eventProgram.components.speakers") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.eventProgram.components.speakersMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsSpeaker ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsSpeaker">
                    <template v-if="form.speakers.length > 0">
                      <div class="custom-grid-table-header">
                        <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
                        <span>{{ $t("contentManagement.eventProgram.components.speakerPresenter") }}</span>
                        <span>{{ $t("contentManagement.eventProgram.components.timeMinutes") }}</span>
                        <span>{{ $t("contentManagement.eventProgram.components.startTime") }}</span>
                        <span>{{ $t("contentManagement.eventProgram.components.viewing") }}</span>
                        <span></span>
                      </div>
                      <div class="speaker-list-container">
                        <draggable :list="form.speakers" tag="div" handle=".el-icon-s-grid" class="list-group-o speaker-list-container" v-bind="dragOptions" @start="dragList = true" @end="speakerListKey += 1" @change="speakerListKey += 1">
                          <div class="item" v-for="(item, index) in form.speakers" :key="index + 'speaker-list-form'" :class="{ passive: !item.isActive, 'error-border': validationErrors.some(x => x.key.includes('speakers[' + index + ']')) }">
                            <div><i class="el-icon-s-grid burger"></i></div>
                            <div :key="speakerListKey">
                              <CustomSelectSpeaker
                                :selectedID="item.speakerID"
                                :selectedPresentationId="item.speakerPresentationId"
                                @speakerId="
                                  id => {
                                    item.speakerID = id;
                                  }
                                "
                                @presentationId="
                                  id => {
                                    item.speakerPresentationId = id;
                                  }
                                "
                              />
                            </div>
                            <div>
                              <el-select v-model.number="item.durationMinutes"><el-option v-for="(item, index) in minuteRange" :key="index" :value="item" @clear="item.durationMinutes = 0" clearable :label="item"></el-option></el-select>
                            </div>
                            <div v-if="form.startTime">
                              <i class="el-icon-time"></i>
                              {{ item.durationMinutes != null ? $moment(timeCalculator(item.durationMinutes, index)).format("HH:mm:ss") : $t("contentManagement.eventProgram.components.selectMin") }}
                            </div>
                            <div v-else>
                              <i class="el-icon-time"></i>
                              {{ $t("contentManagement.eventProgram.components.chooseStartTime") }}
                            </div>
                            <div><el-switch v-model="item.isActive"></el-switch></div>
                            <div class="d-flex justify-content-end">
                              <el-tooltip class="" effect="dark" :content="$t('event.table.delete')" placement="top">
                                <el-popconfirm @confirm="deleteSpeaker(index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                  <el-button slot="reference" type="danger" :loading="loading == 'deleteSpeaker-' + index" circle size="small" icon="fas fa-trash"></el-button>
                                </el-popconfirm>
                              </el-tooltip>
                            </div>
                          </div>
                        </draggable>
                      </div>
                    </template>
                    <el-alert v-else :show-icon="true" type="info" :title="$t('contentManagement.eventProgram.components.noSpeakerMsg')"></el-alert>

                    <div class="btns-list d-flex justify-content-end align-items-center mt-2">
                      <!-- <el-button size="mini" type="primary" round icon="fas fa-plus" @click="addPresentation">{{ $t('contentManagement.eventProgram.components.addNotice') }}</el-button> -->
                      <el-button size="mini" type="primary" round icon="fas fa-plus" @click="addSpeaker">{{ $t("contentManagement.eventProgram.components.addSpeaker") }}</el-button>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.eventProgram.components.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.eventProgram.components.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>{{ $t("contentManagement.eventProgram.components.viewing") }}</label>
                          <span>{{ $t("contentManagement.eventProgram.components.viewingMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label>{{ $t("contentManagement.eventProgram.components.useTags") }}</label>
                          <span>{{ $t("contentManagement.eventProgram.components.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" :key="form.id" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" v-if="loading != 'updateScreenLoading' && form != null" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.eventProgram.components.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("contentManagement.eventProgram.components.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <template v-if="form.id != null">
          <el-tooltip class="item" effect="dark" :content="$t('contentManagement.eventProgram.components.sendReminder')" placement="top">
            <el-popconfirm
              @confirm="
                {
                }
              "
              :confirmButtonText="$t('event.variables.yes')"
              :cancelButtonText="$t('event.buttons.cancel')"
              icon="el-icon-info"
              iconColor="orange"
              :title="$t('contentManagement.eventProgram.components.reminderNotificationMsg')"
            >
              <el-button slot="reference" type="warning" :loading="loading == 'notfiytLoading'" :disabled="loading == 'notfiytLoading'"><i class="fas fa-bell"></i></el-button>
            </el-popconfirm>
          </el-tooltip>
        </template>
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.eventProgram.components.save") }}</el-button>
      </div>
    </div>

    <el-dialog :title="$t('contentManagement.eventProgram.days')" :close-on-click-modal="false" :visible.sync="dayModal" class="large" center append-to-body destroy-on-close>
      <EventDayAddUpdate v-if="dayModal" @closeDialog="dayModal = false" />
    </el-dialog>

    <el-dialog :title="$t('contentManagement.eventProgram.saloons')" :close-on-click-modal="false" :visible.sync="saloonModal" class="large" center append-to-body destroy-on-close>
      <EventSaloonAddUpdate v-if="saloonModal" @closeDialog="saloonModal = false" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import EventSaloonAddUpdate from "./EventSaloonAddUpdate.vue";
import EventDayAddUpdate from "./EventDayAddUpdate.vue";
import { quillEditor } from "vue-quill-editor";
import axios from "axios";
import CustomSelectSpeaker from "../../components/eventprogram/CustomSelectSpeaker.vue";

export default {
  props: ["id"],
  components: {
    EventSaloonAddUpdate,
    EventDayAddUpdate,
    quillEditor,
    CustomSelectSpeaker,
    draggable
  },
  data() {
    return {
      speakerListKey: +new Date(),
      iconList: [
        {
          value: "fas fa-gift",
          title: "Gift"
        },
        {
          value: "fas fa-handshake",
          title: "Handshake"
        },
        {
          value: "fas fa-coffee",
          title: "Coffe Cup"
        },
        {
          value: "fas fa-utensils",
          title: "Dinner"
        },
        {
          value: "fas fa-question",
          title: "Question"
        }
      ],
      minuteRange: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60],
      speakerList: [],
      settingsSpeaker: false,
      axios,
      dayModal: false,
      saloonModal: false,
      dragList: false,
      loading: false,
      timeout: null,
      settingsDock: false,
      form: null,
      validationErrors: [],
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ indent: "-1" }, { indent: "+1" }], [{ color: [] }, { background: [] }], ["clean"], ["link", "image"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      }
    };
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    timeCalculator(minute, index) {
      var d = this.$moment();
      var arrayDate = this.form.startTime.split(":");
      d.set({
        hour: parseInt(arrayDate[0]),
        minute: parseInt(arrayDate[1]),
        second: 0,
        millisecond: 0
      });

      var time = null;

      if (index == 0) {
        time = d;
      } else {
        var speakerTimer = JSON.parse(JSON.stringify(this.form.speakers.filter((x, speakerIndex) => speakerIndex <= index - 1)));
        var totalMinute = 0;
        speakerTimer.map(x => {
          totalMinute += x.durationMinutes;
        });
        time = this.$moment(d).add(totalMinute, "minutes");
      }
      return time;
    },
    deleteSpeaker(index) {
      this.loading = "deleteSpeaker-" + index;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.form.speakers.splice(index, 1);
        this.loading = false;
      }, 500);
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateProgram", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getEventProgram");
        }
        this.loading = false;
      }, 500);
    },
    addSpeaker() {
      var payload = { speakerID: null, speakerPresentationId: null, orderNO: 0, isActive: true, durationMinutes: 0, type: 0 };
      this.form.speakers.push(payload);
    },
    addPresentation() {
      var payload = { speakerID: null, speakerPresentationId: null, orderNO: 0, isActive: true, durationMinutes: 0, type: 1 };
      this.form.speakers.push(payload);
    },
    async speakerSearch(query) {
      var res = await this.axios.post("Speaker/List", { skip: 0, take: 1000, searchTerm: query });
      this.speakerList = res.data.data.items;
    },
    onEditorReady(editor) {
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    selectLocalImage(editor) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file, editor);
          this.quillUploading = "Image upload process started.";
        } else {
          //console.warn("You could only upload images.");
          this.quillUploading = "You could only upload images.";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };
    },
    changeFormType(type) {
      this.form.type = type;
      this.form.speakers = [];
      this.form.subEventID = null;
      this.form.badgeTitle = null;
    },
    saveToServer(file, editor) {
      const fd = new FormData();

      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url, editor);
            this.quillUploading = "Image upload process completed successfully.";
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          } else {
            this.$message.error(body.alert.message);
            this.quillUploading = body.alert.message;
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        } else {
          this.quillUploading = xhr.statusText + " (Code: " + xhr.status + ")";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };

      xhr.send(fd);
    },

    insertToEditor(url, editor) {
      editor.insertEmbed(editor.getSelection().index, "image", url);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getTimeDiffer() {
      if (this.form.startTime != null && this.form.endTime != null) {
        var startTime = this.form.startTime.split(":");
        var endTime = this.form.endTime.split(":");
        var start = new Date();
        var end = new Date();
        start.setHours(startTime[0], startTime[1], 0);
        end.setHours(endTime[0], endTime[1], 0);

        return this.$dateDisplayer(start, end);
      } else {
        return this.$t("contentManagement.eventProgram.components.chooseTime");
      }
    }
  },
  mounted() {
    this.$watch("form.type", () => {
      // this.form.speakers = []
      // this.form.subEventID = null
      // this.form.badgeTitle = null
    });
  },
  watch: {},
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getSubEvents");
      if (this.id != null) {
        var res = await this.$store.dispatch("getEvenProgramOne", this.id);
        this.form = res;
      } else {
        this.form = {
          id: null,
          title: null,
          dayID: null,
          saloonID: null,
          startTime: null,
          endTime: null,
          details: null,
          type: 0,
          speakers: [],
          subEventID: null,
          badgeTitle: null,
          isActive: true,
          enableCustomTags: false,
          customTags: []
        };
      }
      if (this.form.dayID == null && this.$store.state.eventprogram.filter.dayId != null) {
        this.form.dayID = this.$store.state.eventprogram.filter.dayId;
        console.log(this.form.dayID);
      }

      if (this.form.saloonID == null && this.$store.state.eventprogram.filter.saloonId != null) {
        this.form.saloonID = this.$store.state.eventprogram.filter.saloonId;
        console.log(this.form.saloonID);
      }

      if (this.form.subEventID == null && this.$store.state.eventprogram.filter.subEventId != null) {
        this.form.subEventID = this.$store.state.eventprogram.filter.subEventId;
        console.log(this.form.subEventID);
      }
      this.loading = false;
    }, 500);
  }
};
</script>

<style lang="less" scoped>
.custom-grid-table-header {
  grid-template-columns: 30px 1fr 180px 180px 80px 60px !important;
  gap: 1rem;
}
#event-program-add-update-dialog {
  .event-program-title {
    color: black;
    .head {
      font-weight: bold;
    }
  }

  .event-program-type-select {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1rem;
    .item {
      transition: all 0.3s ease-in-out;
      &.active {
        transition: all 0.3s ease-in-out;
        background-color: #03658c;
        color: white;
        .icon {
          background-color: white;
          transition: all 0.3s ease-in-out;
          i {
            color: #03658c;
            transition: all 0.3s ease-in-out;
          }
        }

        .item-content {
          .head {
            color: white;
          }
          .sub {
            color: white;
          }
        }
      }
      height: 75px;
      background: #f1f1f1;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      align-items: center;
      justify-content: flex-start;
      padding: 12px;
      gap: 1rem;

      .icon {
        width: 45px;
        height: 45px;
        aspect-ratio: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #03658c;
        border-radius: 12px;
        i {
          font-size: 16px;
          color: white;
        }
      }
      .item-content {
        .head {
          font-weight: bold;
          font-size: 15px;
          color: #292f3b;
        }
        .sub {
          line-height: 16px;
          font-size: 13px;
          color: #505763;
        }
      }
    }
  }
}
.registerform-input-container {
  .el-upload {
    width: 100% !important;
  }
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    i {
      cursor: pointer;
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    gap: 0.3rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.custom-salon-select-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 15px;
  line-height: 15px;
  height: inherit;
  font-weight: 500;
  color: black;
  .circle-color {
    width: 15px;
    height: 15px;
    border-radius: 50%;
  }
}
.time-differ {
  font-weight: bold;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 5px;
  background-color: #f2f2f2;
  border-radius: 8px;
  height: 40px;
  align-items: center;
  i {
    font-weight: bold;
  }
}
.speaker-list-container {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;
    transition: all 0.5s;
    border-radius: 8px;
    padding: 10px;
    display: grid;
    align-items: center;
    gap: 1rem;
    background-color: #f1f1f1;
    grid-template-columns: 30px 1fr 180px 180px 80px 60px !important;

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }

    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
  }
}
</style>
<style lang="less">
.modal-base-small {
  min-width: 700px;
}
.badge-prefix {
  height: 42px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/eventprogram/EventProgramAddUpdate.vue